<template>
    <modal title="" width="35" :showModal="showModal" @close-modal="closeModal">
      <div>
        
      </div>

    
    </modal>
  </template>
  
  <script>


  export default {
   
  };
  </script>
  
  <style scoped lang="scss">
  .input {
    @apply w-12 h-12 text-primary-black border-2 border-gray-300 flex text-center items-center rounded-md mx-2;
  }
  </style>
  